export function FeedSkeleton() {
  return (
    <div className="space-y-3">
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="card p-4">
          <div className="flex gap-3">
            {/* Vote column skeleton */}
            <div className="flex flex-col items-center gap-1 flex-shrink-0 pt-1">
              <div className="skeleton w-8 h-8 rounded-lg" />
              <div className="skeleton w-6 h-4 rounded" />
              <div className="skeleton w-8 h-8 rounded-lg" />
            </div>
            {/* Content skeleton */}
            <div className="flex-1 min-w-0 space-y-3">
              {/* Meta row */}
              <div className="flex items-center gap-2">
                <div className="skeleton w-16 h-4 rounded-full" />
                <div className="skeleton w-1 h-1 rounded-full" />
                <div className="skeleton w-20 h-4 rounded-full" />
                <div className="skeleton w-1 h-1 rounded-full" />
                <div className="skeleton w-14 h-4 rounded-full" />
              </div>
              {/* Title */}
              <div className="space-y-1.5">
                <div className="skeleton h-5 w-full rounded" />
                {i % 2 === 0 && <div className="skeleton h-5 w-4/5 rounded" />}
              </div>
              {/* Content preview */}
              {i % 3 !== 2 && (
                <div className="space-y-1.5">
                  <div className="skeleton h-3.5 w-full rounded" />
                  <div className="skeleton h-3.5 w-5/6 rounded" />
                  <div className="skeleton h-3.5 w-3/4 rounded" />
                </div>
              )}
              {/* Media placeholder */}
              {i % 4 === 0 && (
                <div className="skeleton h-48 w-full rounded-xl" />
              )}
              {/* Actions */}
              <div className="flex gap-2 pt-1">
                <div className="skeleton h-7 w-24 rounded-xl" />
                <div className="skeleton h-7 w-16 rounded-xl" />
                <div className="skeleton h-7 w-16 rounded-xl" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
